import { WorkFile } from '@/models';

export interface WorkFileState {
  workFile: WorkFile | null
}

export const InitialState: WorkFileState = {
  workFile: null
}
